<template>
<!--车辆选择组件-->
  <div style="position: relative;top: -40px">
    <div
      style="position: relative;left:5%;top:50%;z-index: 999;background-color: #f8f8f9;width: 254px;height: 23.99px;border-radius:5px;box-shadow:0 2px 12px 0 rgba(0,0,0,.3);">
      <div style="position:relative" :style="{top: openselectcartop + 'px'}">
        <List style="background-color: #f8f8f9;" border size="small" v-if="openselectcar">
          <ListItem><p>车辆：</p>
            <AutoComplete
              size="small"
              @on-change="changedata3"
              clearable
              v-model="registrationNum"
              :data="data3"
              :filter-method="filterMethod"
              @on-search="onsearch"
              placeholder="车牌号"
              style="width: 115px; margin-right: 5px;">
            </AutoComplete>
            <Button size="small" type="primary" @click="showSearch">高级查询</Button>
          </ListItem>
          <ListItem><p>开始时间：</p>
            <DatePicker size="small" v-model="startDatetime" ref="producetime" @on-change="showTimePanel('producetime')"
                        :start-date="new Date()" type="datetime" placeholder="开始时间" style="width: 160px"></DatePicker>
          </ListItem>
          <ListItem><p>结束时间：</p>
            <DatePicker size="small" type="datetime" v-model="endDatetime" ref="producetime1" @on-change="showTimePanel1('producetime1')"
                        :start-date="new Date()" placeholder="结束时间" style="width: 160px"></DatePicker>
          </ListItem>
          <ListItem>
            <Button size="small" type="primary" style="margin-right: 20px;"
                    @click="onSearchClick">查询
            </Button>
          </ListItem>
        </List>
        <Row>
          <AutoComplete
            size="small"
            @on-change="changedata3"
            clearable
            v-model="registrationNum"
            :data="data3"
            :filter-method="filterMethod"
            @on-select="onselect"
            placement="top"
            placeholder="车牌号"
            style="width: 190px;">
          </AutoComplete>
          <Button size="small" type="primary"
                  @click="onSearchClick">查询</Button>
          <Button v-if="!openselectcar" size="small" icon="ios-arrow-up" @click="showbox"></Button>
          <Button v-if="openselectcar" size="small" icon="ios-arrow-down" @click="showbox"></Button>
          <Select v-if="registrationNum != null && registrationNum != ''" size="small" v-model="positioningDeviceInfo" style="width: 190px;">
            <Option v-for="item in positioningDeviceInfos" :value="item.terminalNum" :key="item.id">
              {{item.terminalNum + '(' + item.positioningDeviceModel.name + ')'}}
            </Option>
          </Select>
        </Row>
      </div>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue'
  import { GPS } from '@/libs/positonUtils'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import moment from 'moment'
    export default {
        name: "vehicle-choice-model",
      props:{
        registrationNum:{
          required: true
        },
        onSearchClickdisabled:{
          required: true
        }
      },
      data(){
          return{
            /*车辆选择*/
            openselectcartop: 0,
            openselectcar: false,
            startDatetime: '',
            endDatetime: '',
            onSearchClickdisabled: true,

            // registrationNum: '',
            data3: [],

            /**
             * 车辆设备
             */
            terminalNum:null,
            positioningDeviceInfo:null,
            positioningDeviceInfos:[],

          }
      },
      methods:{

        showSearch(){
          this.$emit('showSearch')
        },

        /*车辆选择*/
        showbox () {
          if (this.openselectcar == true) {
            this.openselectcar = false
            this.openselectcartop = 0
          } else {
            this.openselectcar = true
            this.openselectcartop = -165
          }
        },

        changedata3 () {
          this.positioningDeviceInfos = []
          this.positioningDeviceInfo = null
          let t = null
          if (t !== null){
            clearTimeout(t)
          }
          t = setTimeout(()=>{
              console.log(this.registrationNum)
              // this.data3 = []
              if (!this.registrationNum || this.registrationNum === '') {
              } else {
                store.dispatch('VehicleInfoServ_SearchByName', {
                  params: {
                    name:this.registrationNum
                  },
                  urlparams: null
                }).then(res => {
                  this.data3 = []
                  this.list = res.data

                  let result = []
                  for (let i = 0; i < this.list.length; i++) {
                    let str = this.list[i].registrationNum === null ? this.list[i].vin : this.list[i].registrationNum
                    if (str.toUpperCase().indexOf(this.registrationNum.toUpperCase()) !== -1) {
                      result.push(str)
                    }

                    if (this.list[i].customName) {
                      let str1 = this.list[i].customName
                      if (str1.toUpperCase().indexOf(this.registrationNum.toUpperCase()) !== -1) {
                        result.push(str1)
                      }
                    }
                  }
                  let length = result.length> 10 ? 10 : result.length
                  for (let i = 0; i < length; i++) {
                    this.data3.push(result[i])
                  }
                }).catch(err => {
                  this.$Message.error(err)
                })
              }
            }
            ,2000)
        },

        filterMethod () {
          this.onSearchClickdisabled = false

          return true
        },
        onsearch(value){
          console.log(value)
          let queryParams = []
          if (value.length > 6) {
            queryParams.push(genQueryParam('registrationNum', 'EQ', value))
          } else {
            queryParams.push(genQueryParam('customName', 'EQ', value))
          }

          store.dispatch('VehicleInfoServ_GetPage', {
            params: null,
            urlparams: {
              q: queryParams
            }
          }).then(res => {
            this.positioningDeviceInfos = res.data.content[0].positioningDeviceInfos
          }).catch(err => {

          })
        },
        onselect(value){
          console.log(value)
          let queryParams = []
          if (value.length > 6) {
            queryParams.push(genQueryParam('registrationNum', 'EQ', value))
          } else {
            queryParams.push(genQueryParam('customName', 'EQ', value))
          }

          store.dispatch('VehicleInfoServ_GetPage', {
            params: null,
            urlparams: {
              q: queryParams
            }
          }).then(res => {
            this.positioningDeviceInfos = res.data.content[0].positioningDeviceInfos
          }).catch(err => {

          })
        },


        // /*高级搜索*/
        // getTrackNum (registrationNum, terminalNum) {
        //   console.log(terminalNum)
        //   this.registrationNum = registrationNum
        //   this.terminalNum = terminalNum[0].terminalNum
        //   this.vehicleid = terminalNum[0].vehicleInfoId
        //   this.trackSearch = false
        //   if (this.terminalNum != null && this.startDatetime != '' && this.endDatetime != '') {
        //     this.onSearchClickdisabled = false
        //   }
        // },


        /*时间选择器*/
        showTimePanel (refName) {
          /* 此处的onSelectionModeChange方法，就是同点击 选择时间 按钮后触发的方法
        具体此方法的代码逻辑，可以下载组件源码查看 */
          this.$refs[refName].onSelectionModeChange('time')
          if (this.endDatetime != null && this.endDatetime != '' && this.startDatetime > this.endDatetime) {
            this.$Message.error('请选择正确日期和时间，结束日期不能早于开始日期')
          } else {
            if (this.registrationNum != null && this.endDatetime != null && this.endDatetime != '') {
              this.onSearchClickdisabled = false
            }
          }
        },
        showTimePanel1 (refName) {
          /* 此处的onSelectionModeChange方法，就是同点击 选择时间 按钮后触发的方法
        具体此方法的代码逻辑，可以下载组件源码查看 */
          this.$refs[refName].onSelectionModeChange('time')

          if (new Date(this.endDatetime).getHours() == 0 && new Date(this.endDatetime).getMinutes() == 0 && new Date(this.endDatetime).getSeconds() == 0) {
            this.endDatetime = moment(this.endDatetime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }

          if (this.startDatetime != null && this.startDatetime != '' && this.startDatetime > this.endDatetime) {
            this.$Message.error('请选择正确日期和时间，结束日期不能早于开始日期')
          } else {
            if (this.registrationNum != null && this.startDatetime != null && this.startDatetime != '') {
              this.onSearchClickdisabled = false
            }
          }
        },

        /**
         * 按时间格式搜索轨迹数据
         */
        onSearchClick(){
            this.mapLoadding = true
            if ((this.endDatetime - this.startDatetime) > 172799000) {
              this.$Message.error('时间过长，请选择48小时内')
              this.mapLoadding = false
              return
            }
                if (this.startDatetime === '' || this.endDatetime === '') {
                  this.startDate = null
                  this.endDate = null
                  this.$Message.error('请选择日期时间')
                  this.mapLoadding = false
                  return
                }
                let startDate = this.startDatetime
                let endDate = this.endDatetime
                // console.log(this.startDatetime)
                // console.log(this.endDatetime)
                // console.log(this.dateFilter[1] - this.dateFilter[0])
                // if ((this.endDatetime - this.startDatetime) > 172799000) {
                //   this.$Message.error('时间过长，请选择48小时内')
                //   this.mapLoadding = false
                //   return
                // }
                this.startDate = new Date(startDate).Format('yyyy-MM-dd hh:mm:ss')
                this.endDate = new Date(endDate).Format('yyyy-MM-dd hh:mm:ss')
                // console.log(this.terminalNum)
                store.dispatch('TripServ_LoadComplexTripsByStartDatetime', {
                  params: {
                    terminalNum: this.positioningDeviceInfo,
                    startDatetime: this.startDate,
                    endDatetime: this.endDate
                  },
                  urlparams: null
                }).then(res => {
                  if (res.data.locateHistorys.length) {
                    console.log('传入数据')
                    this.locateHistorys = res.data.locateHistorys
                    this.trips = res.data.trips


                    // this.locateHistorys = ['1','2']
                    // this.trips = ['3','4']
                    this.$emit('getlocateHistorys', this.locateHistorys,this.trips,this.registrationNum)
                    this.onSearchClickdisabled = false
                    // console.log(this.locateHistorys)
                    // console.log(this.trips)
                    // console.log('开始绘制')
                    // setTimeout(
                    //   this.$refs.bdMapRef.draw()
                    //   ,500)
                  } else {
                    alert('没有轨迹')
                  }
                  this.mapLoadding = false

                  // // console.log(res.data.locateHistorys)
                  // console.log(res.data.trips)
                  // this.drawMarker(res.data.trips)
                  // this.mapLoadding = false
                  //
                  // // this.LoadComplexTripsByStartDatetime()
                  // if (res.data.locateHistorys.length) {
                  //   // this.content = res.data.locateHistorys
                  //   // this.makecurrentPageContent(this.content)
                  //   // this.initPlayControl()
                  //   // console.log(res.data)
                  //   // this.drawTrack(this.content)
                  //   // this.drawStopPOI(res.data.trips)
                  //
                  //   this.drawLine(res.data.locateHistorys)
                  // } else {
                  //   alert('没有轨迹')
                  // }
                }).catch(err => {
                  // this.locateHistorys = '没有轨迹'
                  // this.trips = '没有轨迹'
                  this.locateHistorys = ['1','2']
                  this.trips = ['3','4']
                  this.$emit('getlocateHistorys', this.locateHistorys,this.trips,this.registrationNum)
                  // this.$refs.bdMapRef.draw()
                  console.log(err)
                  this.mapLoadding = false
                })
        },
        // onSearchClick () {
        //   this.mapLoadding = true
        //   if ((this.endDatetime - this.startDatetime) > 172799000) {
        //     this.$Message.error('时间过长，请选择48小时内')
        //     this.mapLoadding = false
        //     return
        //   }
        //
        //   // console.log(this.registrationNum)
        //   let queryParams = []
        //   console.log(this.registrationNum.length)
        //   if (this.registrationNum.length > 6) {
        //     queryParams.push(genQueryParam('registrationNum', 'EQ', this.registrationNum))
        //   } else {
        //     queryParams.push(genQueryParam('customName', 'EQ', this.registrationNum))
        //   }
        //   // queryParams.push(genQueryParam('customName', 'EQ', this.registrationNum))
        //   store.dispatch('VehicleInfoServ_GetPage', {
        //     params: null,
        //     urlparams: {
        //       q: queryParams
        //     }
        //   }).then(res => {
        //     if (res.data.content.length > 0) {
        //       res.data.content.forEach(item => {
        //         if (this.registrationNum.length > 6) {
        //           if (item.registrationNum === this.registrationNum) {
        //             this.terminalNum = item.positioningDeviceInfos[0].terminalNum
        //             this.vehicleid = item.id
        //           }
        //         } else {
        //           if (item.customName === this.registrationNum) {
        //             this.terminalNum = item.positioningDeviceInfos[0].terminalNum
        //             this.vehicleid = item.id
        //           }
        //         }
        //       })
        //       // this.terminalNum = res.data.content[0].positioningDeviceInfos[0].terminalNum
        //       // this.vehicleid = res.data.content[0].id
        //       console.log(this.terminalNum)
        //       console.log(this.vehicleid)
        //
        //       if (this.startDatetime === '' || this.endDatetime === '') {
        //         this.startDate = null
        //         this.endDate = null
        //         this.$Message.error('请选择日期时间')
        //         this.mapLoadding = false
        //         return
        //       }
        //       let startDate = this.startDatetime
        //       let endDate = this.endDatetime
        //       // console.log(this.startDatetime)
        //       // console.log(this.endDatetime)
        //       // console.log(this.dateFilter[1] - this.dateFilter[0])
        //       // if ((this.endDatetime - this.startDatetime) > 172799000) {
        //       //   this.$Message.error('时间过长，请选择48小时内')
        //       //   this.mapLoadding = false
        //       //   return
        //       // }
        //       this.startDate = new Date(startDate).Format('yyyy-MM-dd hh:mm:ss')
        //       this.endDate = new Date(endDate).Format('yyyy-MM-dd hh:mm:ss')
        //       // console.log(this.terminalNum)
        //       store.dispatch('TripServ_LoadComplexTripsByStartDatetime', {
        //         params: {
        //           terminalNum: this.terminalNum,
        //           startDatetime: this.startDate,
        //           endDatetime: this.endDate
        //         },
        //         urlparams: null
        //       }).then(res => {
        //         if (res.data.locateHistorys.length) {
        //           console.log('传入数据')
        //           this.locateHistorys = res.data.locateHistorys
        //           this.trips = res.data.trips
        //
        //
        //           // this.locateHistorys = ['1','2']
        //           // this.trips = ['3','4']
        //           this.$emit('getlocateHistorys', this.locateHistorys,this.trips)
        //           // console.log(this.locateHistorys)
        //           // console.log(this.trips)
        //           // console.log('开始绘制')
        //           // setTimeout(
        //           //   this.$refs.bdMapRef.draw()
        //           //   ,500)
        //         } else {
        //           alert('没有轨迹')
        //         }
        //         this.mapLoadding = false
        //
        //         // // console.log(res.data.locateHistorys)
        //         // console.log(res.data.trips)
        //         // this.drawMarker(res.data.trips)
        //         // this.mapLoadding = false
        //         //
        //         // // this.LoadComplexTripsByStartDatetime()
        //         // if (res.data.locateHistorys.length) {
        //         //   // this.content = res.data.locateHistorys
        //         //   // this.makecurrentPageContent(this.content)
        //         //   // this.initPlayControl()
        //         //   // console.log(res.data)
        //         //   // this.drawTrack(this.content)
        //         //   // this.drawStopPOI(res.data.trips)
        //         //
        //         //   this.drawLine(res.data.locateHistorys)
        //         // } else {
        //         //   alert('没有轨迹')
        //         // }
        //       }).catch(err => {
        //         // this.locateHistorys = '没有轨迹'
        //         // this.trips = '没有轨迹'
        //         // this.$refs.bdMapRef.draw()
        //         console.log(err)
        //         this.mapLoadding = false
        //       })
        //     }
        //   }).catch(err => {
        //     console.log(err)
        //     this.mapLoadding = false
        //   })
        // },
      },
      computed: {
        _registrationNum: {
          get () {
            return this.registrationNum
          },

          set (val) {
            // this.$emit('input', val)
            // this.$emit('change', val)
          }
        },
        _onSearchClickdisabled: {
          get () {
            return this.onSearchClickdisabled
          },

          set (val) {
            // this.$emit('input', val)
            // this.$emit('change', val)
          }
        }
      },

      mounted() {
        /*初始化时间*/
        this.startDatetime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.endDatetime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')

      }
    }
</script>

<style scoped>

</style>
